import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetDraftPlotTaskStatus } from '@/api/rest/resources/plot';

import { UNKNOWN_ERROR_KEY } from '../utils';

type UploadTaskPollerParams = {
  taskId: string | null;
  isActive: boolean;
  onSuccess: () => void;
  onError: (message: string | null) => void;
};

export const useUploadTaskPoller = ({ taskId, isActive, onSuccess, onError }: UploadTaskPollerParams) => {
  const { t } = useTranslation();

  const { data: uploadTaskStatus } = useGetDraftPlotTaskStatus(
    { queryParams: { task_id: taskId ?? '' } },
    { enabled: !!taskId && isActive, refetchInterval: 2000 },
  );

  useEffect(() => {
    if (!uploadTaskStatus) return;
    if (uploadTaskStatus.status === 'SUCCESS') {
      onSuccess();
    } else if (uploadTaskStatus.status === 'FAILED') {
      onError(uploadTaskStatus.error_message ?? t(UNKNOWN_ERROR_KEY));
    }
  }, [uploadTaskStatus, onSuccess, onError, t]);
};
